import { create, windowScheduler } from "@yornaath/batshit";
import apiClient from "services/ApiClient";
import { createQueryString } from "helpers/queryString";
import { BATCH_WINDOW_MS, keyedObjectResolver } from "helpers/batcher";
import { User, UserId } from "./models";

interface UserBatchKey {
  id: UserId;
  withJourneyAssociations?: boolean;
}

// Create separate batchers for different query types
const createUserBatcher = (withJourneyAssociations: boolean = false) => create({
  fetcher: async (keys: UserBatchKey[]): Promise<Record<UserId, User>> => {
    const userIds = keys.map((key) => key.id);
    const additionalQueries: Record<string, any> = { ids: userIds };

    if (withJourneyAssociations) {
      additionalQueries.with_journey_associations = true;
    }

    const queryString = createQueryString({ additionalQueries });

    // Backend returns { data: { "123": {...}, "456": {...} } }
    const response = await apiClient.performRequest<{ data: Record<UserId, User> }>(
      `/api/users/batch?${queryString}`,
    );

    return response.payload.data;
  },
  resolver: keyedObjectResolver("id"),
  scheduler: windowScheduler(BATCH_WINDOW_MS),
});

// Default batcher without journey associations (buddy, people_team_contact, manager)
const userBatcher = createUserBatcher(false);

// Batcher with journey associations included
const userBatcherWithJourneyAssociations = createUserBatcher(true);

export default userBatcher;
export { userBatcherWithJourneyAssociations };
